<!DOCTYPE html>
<html>
<head>
  <title>Flowtrics Resident View</title>
  <style>
    html, body {
      margin: 0;
      padding: 0;
      height: 100%;
    }

    iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  </style>
</head>
<body>
 <div style="height: 100vh; width: 100%;">
  <iframe
    src="https://buck-arc-54935417.figma.site/"
    class="full-height-iframe">
  </iframe>
</div>
</body>
</html>
